// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder_placeholder__2RxZg","hangle":"Placeholder_hangle__liSip","number":"Placeholder_number__3Ddg5","isCompletedHangle":"Placeholder_isCompletedHangle__2JBqY"};